<template>
  <div class="cart-coupons">
    <div class="checkout__header">
      <div class="cart__search">
        <label
          for="coupon-input"
          class="cart__search__label"
        >
          <h3 class="checkout__header__heading">{{ $modeoL10n.discount_code }}</h3>
        </label>

        <div class="cart__search__input-container">
          <input
            id="coupon-input"
            v-model="coupon"
            type="text"
            autocomplete="new-password"
            class="cart__search__input cart__search__input--with-submit cart__search__input--small-in-mobile small"
            :placeholder="$modeoL10n.enter_coupon_code"
            @keydown.enter.prevent
            @keydown="handleKeyDown()"
          >
          <button
            class="cart__search__submit btn btn--small"
            @click.prevent="applyCoupon"
          >
            {{ $modeoL10n.add }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="appliedCoupons && appliedCoupons.length"
      class="checkout__subsection"
    >
      {{ $modeoL10n.applied }} {{ appliedCoupons.length > 1 ? $modeoL10n.discount_code_plural : $modeoL10n.discount_code_singular }}
      <div
        v-for="(appliedCoupon, index) in appliedCoupons"
        :key="index"
        class="checkout__coupon"
      >
        <strong>{{ appliedCoupon.code }}</strong>
        <button
          class="checkout__coupon--remove btn"
          @click.prevent="removeCoupon(appliedCoupon.code)"
        >
          <span class="screen-reader-text">{{ $modeoL10n.remove }}</span>
        </button>
        <template v-if="appliedCoupon.description">
          <span class="checkout__coupon--description">
            {{ appliedCoupon.description }}
          </span>
        </template>
      </div>
    </div>

    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="errorMessage"
      class="error-notification"
      v-html="$sanitize(errorMessage)"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        nonce: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            coupon: null,
            errorMessage: null,
        };
    },

    computed: {
        appliedCoupons() {
            return this.$store.getters.getCoupons;
        },
    },

    methods: {
        handleKeyDown() {
            if (event.key === 'Enter') {
                this.applyCoupon();
            } else {
                this.errorMessage = null;
            }
        },

        applyCoupon() {
            let request = {
                "coupon": this.coupon,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
            }

            axios.post('/wp-json/modeo/v2/cart/apply_coupon', request, config)
            .then(response => {
                this.updateTotals(response.data);
                this.updateErrorMessage(response.data.status_messages);
                this.updateShippingMethods(response.data);

                // coupon ok, clear field
                if (response.data.status === true) {
                    this.coupon = '';
                }
            })
            .catch((error) => {
                this.catchError(error);
            });
        },

        removeCoupon(coupon) {
            let request = {
                "coupon": coupon,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
            }

            axios.post('/wp-json/modeo/v2/cart/remove_coupon', request, config)
            .then(response => {
                this.updateTotals(response.data);
                this.updateErrorMessage(response.data.status_messages);
                this.updateShippingMethods(response.data);

                // coupon removed, clear field to make clear no coupons are applied
                this.coupon = '';
            })
            .catch((error) => {
                this.catchError(error);
            });
        },

        updateShippingMethods(data) {
            this.$store.commit('setShippingMethods', data.shipping_methods);
        },

        updateTotals(data) {
            this.$store.commit('setCoupons', data.coupons);

            const totals = {
                subtotal: data.subtotal,
                subtotalTax: data.subtotal_tax,
                total: data.total,
                discount: data.discount_total,
                discountTax: data.discount_tax,
                count: data.cart_product_count,
            };

            this.$store.commit('setTotals', totals);
        },

        updateErrorMessage(errorMessage) {
            if (typeof errorMessage !== 'undefined' && errorMessage.length > 0) {
                if (typeof errorMessage === 'string') {
                    this.errorMessage = errorMessage;
                } else {
                    this.errorMessage = errorMessage.join('\n');
                }
            } else {
                this.errorMessage = null;
            }
        },

        catchError(error) {
            if ( error.response ) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log( error.response.data );
                console.log( error.response.status );
                console.log( error.response.headers );
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log( 'Error', error.message );
            }
            console.log( error.config );
        },
    },
}
</script>
